import { render, staticRenderFns } from "./processNonRiskbook.vue?vue&type=template&id=d4c646f2"
import script from "./processNonRiskbook.vue?vue&type=script&lang=js"
export * from "./processNonRiskbook.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d4c646f2')) {
      api.createRecord('d4c646f2', component.options)
    } else {
      api.reload('d4c646f2', component.options)
    }
    module.hot.accept("./processNonRiskbook.vue?vue&type=template&id=d4c646f2", function () {
      api.rerender('d4c646f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/dashboard/processRam/processNonRiskbook.vue"
export default component.exports